import { HStack, StackProps } from '@chakra-ui/react';

import { ExternalLink } from '$components/chakra/external-link';

interface LinksProps extends StackProps {
  repository?: string | null;
  url?: string | null;
}

export function Links({ repository, url, ...props }: LinksProps) {
  return (
    <HStack spacing="20px" wrap="wrap" {...props}>
      {url && (
        <ExternalLink href={url} fontFamily="mono" fontSize="13px">
          Live ↗
        </ExternalLink>
      )}
      {repository && (
        <ExternalLink href={repository} fontFamily="mono" fontSize="13px">
          Repo ↗
        </ExternalLink>
      )}
    </HStack>
  );
}
